import { InformesComponent } from './components/servicio-medico/informes/informes.component';
import { IASSSeguimientoComponent } from "./components/calidad/iass-seguimiento/iass-seguimiento.component";
import { LoginGuard } from './guards/login.guard';
import { InformesCalidadComponent } from './components/informes-calidad/informes-calidad.component';
import { UsersComponent } from './components/users/users.component';
import { BeneficiariosComponent } from './components/apoyo-usuario/beneficiarios/beneficiarios.component';
import { TitularesComponent } from './components/apoyo-usuario/titulares/titulares.component';
import { AuditoriasComponent } from './components/apoyo-usuario/auditorias/auditorias.component';
import { MonitoreoComponent } from './components/apoyo-usuario/monitoreo/monitoreo.component';
import { ProgramarCobrosComponent } from './components/cartera/programar-cobros/programar-cobros.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContratosRegistradosComponent } from './components/contratos/contratos-registrados/contratos-registrados.component';
import { PreContratosComponent } from './components/contratos/pre-contratos/pre-contratos.component';
import { IassAuditoriaComponent } from './components/calidad/iass-auditoria/iass-auditoria.component';
import { SolicitarPermisosComponent } from './components/recursos-humanos/solicitar-permisos/solicitar-permisos.component';
import { VerCobrosCarteraComponent } from './components/cartera/ver-cobros-cartera/ver-cobros-cartera.component';
import { VerAgendaComponent } from './components/agenda/ver-agenda/ver-agenda.component';
import { CircularZeroTwentyComponent } from './components/informes-generales/circular-zero-twenty/circular-zero-twenty.component';
import { LoginComponent } from './main/pages/authentication/login/login.component';
import { DespachoComponent } from './components/servicio-medico/despacho/despacho.component';
import { PermisosGuard } from './guards/permisos.guard';
import { GestionIngresoUsuariosComponent } from './components/fidelizacion-clientes/gestion-ingreso-usuarios/gestion-ingreso-usuarios.component';
import { InformesServicioClienteComponent } from './components/informes-servicio-cliente/informes-servicio-cliente.component';
import { ProgramarCobrosFijoComponent } from './components/cartera/programar-cobros-fijo/programar-cobros-fijo.component';
import { ConsultarUsuarioComponent } from './components/general/consultar-usuario/consultar-usuario.component';
import { ConsultarTitularComponent } from './components/general/consultar-titular/consultar-titular.component';
import { AgendaPersonalComponent } from './components/agenda/agenda-personal/agenda-personal.component';
import { RegistrarCobroFijoComponent } from './components/cartera/registrar-cobro-fijo/registrar-cobro-fijo.component';
import { ConsultarContratoComponent } from './components/general/consultar-contrato/consultar-contrato.component';
import { DireccionesComponent } from './components/temporales/direcciones/direcciones.component';
import { AnalyticsDashboardComponent } from './main/apps/dashboards/analytics/analytics.component';
import { AgregarDebitoAutoComponent } from './components/debito-automatico/agregar-debito-auto/agregar-debito-auto.component';
import { RegistrarDebitoAutoComponent } from './components/debito-automatico/registrar-debito-auto/registrar-debito-auto.component';
import { DashboardServicioMedicoComponent } from './components/servicio-medico/dashboard-servicio-medico/dashboard-servicio-medico.component';
import { AgendaCobradorComponent } from './components/cobrador/agenda-cobrador/agenda-cobrador.component';
import { EntregaFacturaComponent } from './components/cobrador/entrega-factura/entrega-factura.component';
import { DashboardCobranzaComponent } from './components/cobranza/dashboard-cobranza/dashboard-cobranza.component';
import { PostServicioComponent } from './components/servicio-al-cliente/post-servicio/post-servicio.component';
import { AuditoriaCarteraComponent } from './components/cartera/informes-cartera/auditoria-cartera/auditoria-cartera.component';
import { MainComponent } from './cartera-vencida/main.component';


// Routing modules

import { FinanzasComponent } from './finanzas/finanzas.component';
import { GestionarCarteraComponent } from './components/cartera/informes-cartera/gestionar-cartera/gestionar-cartera.component';


 //contratosRegistrados data:{id_permiso:3}

const appRoutes: Routes = [
    {
        path:'personal',
        children:[
            {
            path:'agenda-personal',
            children:[
                { path: 'agenda/:origen', loadChildren: './main/apps/calendar/calendar.module#CalendarModule', canActivate: [LoginGuard] },
                { path: 'ver-agenda', canActivate: [LoginGuard] ,component: VerAgendaComponent }
            ]
            },
            /* {
                path:'notas',
                children:[
                    { path: 'notas-activas',canActivate: [LoginGuard] },
                    { path: 'notas-archivadas',canActivate: [LoginGuard] }
                ]
            } */
        ]
    },

    {
        path:'general',
        children:[
            { path: 'consultar-usuario', canActivate: [LoginGuard], component: ConsultarUsuarioComponent },
            { path: 'consultar-titular', canActivate: [LoginGuard], component: ConsultarTitularComponent },
            { path: 'consultar-contrato',canActivate: [LoginGuard], component: ConsultarContratoComponent }
        ]
    },
    
    {
        path:'contratos',
        data: { id_permiso: 1 },
        canActivate: [LoginGuard, PermisosGuard],
        children:[
            /* {
                path:'dashboard-contratos',
                canActivate: [LoginGuard, PermisosGuard],
                data:{id_permiso:2},
                children:[
                    { path: 'estadisticas',canActivate: [LoginGuard, PermisosGuard], data:{id_permiso:3} }
                ]
            }, */
            {
                path:'contratos-registrados',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 4 } ,
                children:[
                    { path: 'consultar-contrato', component: ContratosRegistradosComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 5 } }
                ]
            },
            /* {
                path:'pre-contratos',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 6 },
                children:[
                    { path:'pendientes',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 7 } },
                    { path:'aprobados', canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 8 } }
                ]
            },
            {
                path:'bitacora-contratos',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 10 },
                children:[
                    { path:'bitacora-historico',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 11 } },
                    { path:'bitacora-auditoria',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 12 } },
                    { path:'bitacora-rangos',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 13 } },
                    { path:'bitacora-documentos',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 14  } }
                ]
            },
            {
                path:'otros',
                canActivate: [LoginGuard, PermisosGuard],
                { id_permiso: 15 },
                children:[
                    { path:'alianzas',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 16 } },
                    { path:'tarifas', canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 17 } }
                ]
            },
            {
                path:'info-contratos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 18 }
            } */
        ]
    },
    {
        path:'cobranza',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 19 },
        children:[
            {
                path:'dashboard-cobranza',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 20 },
                children:[
                    { path:'estadisticas', component: DashboardCobranzaComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 21 } }
                ]
            },
            {
                path:'cartera',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 22 },
                children:[
                    {
                        path: 'cobros-fijos',
                        canActivate: [LoginGuard],
                        children: [
                            { path: 'agregar-cobros', component: ProgramarCobrosFijoComponent, canActivate: [LoginGuard] },
                            { path: 'registrar-cobro', component: RegistrarCobroFijoComponent, canActivate: [LoginGuard] },
                            // tslint:disable-next-line: max-line-length
                            { path: 'agenda-calendario/:origen/:indice/:empresa/:codigo', loadChildren: './main/apps/calendar/calendar.module#CalendarModule', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 24 } }
                        ]
                    },
                    {
                        path: 'cobros-ocasionales',
                        canActivate: [LoginGuard],
                        children: [
                            { path: 'programar-cobros', component: ProgramarCobrosComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 23 }  },
                            { path: 'ver-cobros', component: VerCobrosCarteraComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 24 } },
                            // tslint:disable-next-line: max-line-length
                            { path: 'agenda-calendario/:origen/:indice/:empresa/:codigo', loadChildren: './main/apps/calendar/calendar.module#CalendarModule', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 24 } },
                            // tslint:disable-next-line: max-line-length
                            { path: 'agenda-calendario/:origen', loadChildren: './main/apps/calendar/calendar.module#CalendarModule', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 24 } }
                        ]
                    },
                    {
                        path:'vencida', component:MainComponent, canActivate:[LoginGuard]
                    }
                ]
            },
            {
                path:'debitos-activos',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 31 },
                children: [
                    { path: 'registrar-debitos', component: RegistrarDebitoAutoComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 32 } },
                    /* { path: 'gestionar-debitos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 33 } },
                    { path: 'historico-debitos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 34 } }, */
                    { path: 'agregar-debito-auto', component: AgregarDebitoAutoComponent, canActivate: [LoginGuard], data: { id_permiso: 34 } }
                ]
            },
            {
                path:'cobrador',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 25 },
                children:[
                    { path: 'ver-agenda', component: AgendaCobradorComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 26 } },
                    { path: 'entrega-factura', component: EntregaFacturaComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 27 }}
                ]
            },
            /* {
                path:'tesoreria',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 28 },
                children:[
                    { path: 'debitos-aprobados',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 29 } },
                    { path: 'gestion-cobrador', canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 30 }}
                ]
            },*/
            {
                path: 'informes-cobranza',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 35 },
                children: [
                    { path: 'auditoria-cartera', component: AuditoriaCarteraComponent, canActivate: [LoginGuard, PermisosGuard] },
                    { path: 'gestion-cartera', component: GestionarCarteraComponent, canActivate: [LoginGuard, PermisosGuard] },
                ]
            },
            {
                path:'vencida',component:MainComponent
            },
        ],
    },
    /* {
        path: 'Contabilidad',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 36 },
        children:[
            { path:'desprendibles-nomina', canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 37 } },
            { path:'informes-contabilidad', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 38 } },
            {
                path: 'proveedor',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 39 },
                children:[
                    { path: 'crear-proveedor', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 40 } },
                    { path: 'registrar-factura ', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 41 } },
                    { path: 'facturas-por-pagar', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 102 } },
                    { path: 'historial-facturas-por-proveedor', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 42 } }
                ]
            }
        ]
    }, */
    /* {
        path:'Facturacion',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 43 },
        children:[
            { path: 'generar-facturas', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso:44  } },
            { path: 'ver-facturas', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 45 } },
            { path: 'notificar-factura', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 46 } }
        ]
    }, */
    {
        path:'servicio-medico',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 47 },
        children:[
            {
                path:'dashboard-servicio-medico',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 48 },
                children:[
                    { path: 'estadisticas', component: DashboardServicioMedicoComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 49 }, }
                ]
            },
            {
                path:'informes-servicio-medico',component: InformesComponent
            },
            {
                path: 'despacho', component: DespachoComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 50 },
            },
            {
                path:'finanzas', component: FinanzasComponent, canActivate: [LoginGuard, PermisosGuard]
            },
            /* {
                path:'historias-clinicas',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 51 }
            },
            {
                path:'farmacia',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 52 },
                children:[
                    { path: 'inventario-medicamentos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 53 } },
                    { path: 'consumos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 54 } }
                ]
            }, */
            {
                path:'calidad',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 55 },
                children:[
                    { path: 'IASSseguimiento', component: IASSSeguimientoComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 56 } },
                    { path: 'IASSAuditoria', component: IassAuditoriaComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 56 } },
                    { path: 'Informes-calidad', component: InformesCalidadComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 57 } }
                ]
            },
            /*  {
                path:'gestion-personal-operativo',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 58 },
                children:[
                    { path: 'agregar-personal',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 59 } },
                    {
                        path:'turnos',
                        canActivate: [LoginGuard, PermisosGuard],
                        data: { id_permiso: 60 },
                        children:[
                            { path: 'asignar-turnos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 61 } },
                            { path: 'gestionar-turnos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 62 } },
                            { path: 'cambio-turnos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 63 } },
                            { path: 'turnos-extras', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 64 } }
                        ]
                    }
                ]
            },
            {
                path:'informes-servicio-medico', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 65 }
            } */
        ]
    },
    {
        path:'servicio-cliente',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 72 },
        children:[
            /* { path:'PQRS',canActivate: [LoginGuard, PermisosGuard] }, data: { id_permiso: 73 } },*/
            { path: 'post-servicio',component:PostServicioComponent,canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 74 } },
            {
                path: 'apoyo-usuario',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 75 },
                children: [
                    { path: 'beneficiarios', component: BeneficiariosComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 76 } },
                    { path: 'titulares', component: TitularesComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 77 } },
                    { path: 'auditorias', component: AuditoriasComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 78 } },
                    { path: 'monitoreo', component: MonitoreoComponent, canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 79 } }
                ]
            },
            {
                path: 'fidelizacion-clientes',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 80 },
                children: [
                    { path: 'gestion-ingreso-usuarios', component: GestionIngresoUsuariosComponent, canActivate: [LoginGuard]}
                ]
            }
            /* { path: 'informes-servicio-cliente', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 81 } } */
        ]
    },
   /*  {
        path:'comercial',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 66 },
        children:[
            {
                path:'dashboard-comercial',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 67 },
                children:[
                    { path: 'estadisticas',canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 68 } }
                ]
            },
            {
                path:'gestion-contratos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 69 }
            },
            {
                path:'gestion-empresas', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 70 }
            },
            {
                path:'informes-comercial', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 71 }
            }
        ]
    },
    {
        path:'mercadeo',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 82 },
        children:[
            {
                path:'mensajes-texto',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 83 },
                children:[
                    { path: 'predefinidos',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 84 } },
                    { path: 'mensajes-personalizados',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 85 } }
                ]
            }
        ]
    },
    {
        path:'recursos-humanos',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 86 },
        children:[
            { path:'solicitar-permisos', canActivate: [LoginGuard, PermisosGuard] },
            { path: 'solicitud-de-permisos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 87 }},
            {
                path: 'personal',
                canActivate: [LoginGuard, PermisosGuard],
                data: { id_permiso: 88 },
                children:[
                    { path: 'hoja-de-vida', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 89 } },
                    { path: 'novedades', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 90 } }
                ]
            },

        ]
    },
    {
        path:'sistemas',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 91 },
        children:[
            { path: 'gestionar-usuario', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 92 } },
            { path: 'agregar-usuario', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 93 } },
            { path: 'permisos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 94 } },
            { path: 'soporte-tecnico', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 95 } },
            { path: 'inventario-equipos', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 96 } }
        ]
    },*/
    {
        path:'informes',
        canActivate: [LoginGuard, PermisosGuard],
        data: { id_permiso: 97 },
        children:[
            //{ path: 'area-operativa',canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 98 } },
            //{ path: 'area-administrativa', canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 99 } },
            //{ path: 'area-comercial', canActivate: [LoginGuard, PermisosGuard],data: { id_permiso: 100 } },
            { path: 'area-servicio-cliente', component: InformesServicioClienteComponent,
            canActivate: [LoginGuard, PermisosGuard], data: { id_permiso: 101 } }
        ]
    },
    {
        path:'',
        redirectTo:'/personal/agenda-personal',
        pathMatch:'full'
    },
    {
        path:'temporales',
        children:[
            {path:'direcciones',component:DireccionesComponent}
        ]
    },
    {path:'',component:VerAgendaComponent}
]

@NgModule({
    imports:[RouterModule.forRoot(appRoutes, {useHash:true})]
})
export class AppRoutingModule{}
